import React from "react";

const FilterIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.3335 5C3.3335 3.61929 4.45278 2.5 5.8335 2.5H14.1668C15.5475 2.5 16.6668 3.61929 16.6668 5V5.9244C16.6668 6.63311 16.366 7.30853 15.8392 7.78263L12.5002 10.7878V15.3183C12.5002 15.9496 12.1435 16.5267 11.5789 16.809L9.91218 17.6424C8.80402 18.1964 7.50016 17.3906 7.50016 16.1516V10.7878L4.16108 7.78263C3.6343 7.30853 3.3335 6.63311 3.3335 5.9244V5ZM5.8335 4.16667C5.37326 4.16667 5.00016 4.53976 5.00016 5V5.9244C5.00016 6.16063 5.10043 6.38577 5.27603 6.54381L8.6151 9.54898C8.96629 9.86505 9.16683 10.3153 9.16683 10.7878V16.1516L10.8335 15.3183V10.7878C10.8335 10.3153 11.034 9.86505 11.3852 9.54898L14.7243 6.54381C14.8999 6.38577 15.0002 6.16063 15.0002 5.9244V5C15.0002 4.53976 14.6271 4.16667 14.1668 4.16667H5.8335Z"
        fill="#646F87"
      />
    </svg>
  );
};

export default FilterIcon;
